import React from 'react';
import { useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';
import useHousingStockHousesState from '../../../../../hooks/useHousingStockHousesState';
import changeHouseStage from '../../../../../requests/changeHouseStage';
import { getQueryKeys } from '../../../../../queries/queryKeys';
import { texts } from '../../../../../constants/texts';
import Stages from '../../../../../components/common/Stages/Stages';

const HouseStage = () => {
  const queryClient = useQueryClient();

  const stages = queryClient.getQueryState(getQueryKeys.houseStages());

  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const { isFetching: isHouseFetching } = queryClient.getQueryState(
    getQueryKeys.housingStockHouses({ houseId: currentHouse?.houseId })
  );

  const { housingStockHousesQueryKey } = useHousingStockHousesState();

  const changeStageMutation = useMutation(
    ({ values }) => changeHouseStage(values),
    {
      onSuccess: (_data, { values }) => {
        queryClient.invalidateQueries(
          getQueryKeys.housingStockHouses({ houseId: values.houseId })
        );

        queryClient.invalidateQueries(housingStockHousesQueryKey);
      },
    }
  );

  const handleMenuClick = (key) => {
    const stageId = Number(key);

    if (stageId !== currentHouse?.houseStageId) {
      const values = {
        houseId: currentHouse?.houseId,
        stageId,
      };

      changeStageMutation.mutate({ values });
    }
  };

  return (
    <Stages
      loading={
        stages?.isFetching || isHouseFetching || changeStageMutation.isLoading
      }
      stages={stages?.data || []}
      selectedKeys={
        currentHouse?.houseStageId ? [String(currentHouse.houseStageId)] : []
      }
      title={texts.houseStage}
      onMenuClick={handleMenuClick}
      stageName={currentHouse?.houseStageName || '-'}
    />
  );
};

export default HouseStage;
